




































































































































































































import Vue from 'vue';
import * as R from 'ramda';
import { Location } from 'vue-router';
import { User } from '@/core/entity';

import SideMenu from '@/vue/components/AppSideMenu.vue';

export default Vue.extend({
  components: {
    'side-menu': SideMenu,
  },

  data() {
    return {
      collapsed: false,
    };
  },

  computed: {
    currentUser(): User | null {
      return this.$store.state.user;
    },

    isAuthenticated(): boolean {
      return this.$store.state.user !== null;
    },

    routes(): any[] {
      if (this.$route.matched.length === 1) {
        return [];
      }

      const params = this.$route.params;
      const keys = R.keys(params);

      return [
        {
          name: 'Home',
          icon: 'home',
          path: '/home',
        },
        ...R.map((r) => {
          let path = r.path;
          R.forEach((key) => {
            if (path.indexOf(`:${key}`) !== -1) {
              path = path.replace(`:${key}`, params[key]);
            }
          }, keys);
          return {
            name: r.meta.breadcrumbName,
            path,
          };
        }, this.$route.matched),
      ];
    },
  },

  methods: {
    onAuthMenuClick({ key }: { key: string }) {
      if (key === 'change-password') {
        this.$router.push({ name: 'change-password' });
      } else if (key === 'sign-out') {
        this.$coreApp.auth.signOut((err, user, next) => {
          if (err === null) {
            this.$message.success('Signed out');
            this.$store.commit('setUser', user);
          }

          if (next) {
            this.$router.replace(next);
          }
        });
      }
    },
  },
});
